import {I18n} from '@lingui/core';
import {ShopperInteractionPublicEnum} from '../types';
import {FundingSourceEnum} from './enums/splitConfigurationEnums';

export const FEE_MIN_AND_MAX_RESTRICTIONS = {
  minFixedFee: 0,
  maxFixedFee: 10000, // $100

  minInteracSplitFixed: 0,
  maxInteracSplitFixed: 10000,

  minAmexSplitFixed: 0,
  maxAmexSplitFixed: 10000,

  minAchSplitFixed: 10,
  maxAchSplitFixed: 1000,

  minPercentage: 0,
  maxPercentage: 1000, // 100%

  minPerRefundFee: 0,
  maxPerRefundFee: 10000, // $100

  minPerChargebackFee: 0,
  maxPerChargebackFee: 10000, // $100

  minPerDeviceFee: 0,
  maxPerDeviceFee: 50000, // $500

  minTenantIntervalFee: 0,
  maxTenantIntervalFee: 100000, // $1000
};

export const getShopperInteractionLabels = (
  i18n?: I18n
): Record<ShopperInteractionPublicEnum, string> => ({
  [ShopperInteractionPublicEnum.Any]: i18n
    ? i18n._('ANY – All sales channels')
    : 'ANY – All sales channels',
  [ShopperInteractionPublicEnum.Ecommerce]: i18n
    ? i18n._('Ecommerce – Online payments')
    : 'Ecommerce – Online payments',
  [ShopperInteractionPublicEnum.Pos]: i18n
    ? i18n._('POS – In-person terminal payments')
    : 'POS – In-person terminal payments',
  [ShopperInteractionPublicEnum.ContAuth]: i18n
    ? i18n._('ContAuth – Stored card or subscriptions')
    : 'ContAuth – Stored card or subscriptions',
  [ShopperInteractionPublicEnum.Moto]: i18n
    ? i18n._('Moto – Mail or phone orders')
    : 'Moto – Mail or phone orders',
});

export const allShopperInteractions = Object.values(ShopperInteractionPublicEnum);

export const getFundingSourceLabels = (i18n?: I18n): Record<FundingSourceEnum, string> => ({
  [FundingSourceEnum.ANY]: i18n ? i18n._('ANY – All funding sources') : 'ANY – All funding sources',
  [FundingSourceEnum.CREDIT]: i18n ? i18n._('Credit – Credit cards') : 'Credit – Credit cards',
  [FundingSourceEnum.DEBIT]: i18n ? i18n._('Debit – Debit cards') : 'Debit – Debit cards',
  [FundingSourceEnum.DEFERRED_DEBIT]: i18n
    ? i18n._('Deferred debit – Deferred Debit cards')
    : 'Deferred debit – Deferred Debit cards',
  [FundingSourceEnum.PREPAID]: i18n ? i18n._('Prepaid – Prepaid cards') : 'Prepaid – Prepaid cards',
  [FundingSourceEnum.CHARGED]: i18n ? i18n._('Charged – Charged cards') : 'Charged – Charged cards',
});

export const allFundingSources = Object.values(FundingSourceEnum);
